<script>
    export default {
        name: "notFound",
    head: {
      title() {
        return {
          inner: 'Não encontrado',
          complement: 'Voto Legal',
        };
      },
      meta() {
        return [
          {
            name: 'prerender-status-code',
            content: 404,
          },
        ];
      }
    },
  }
</script>

<template>
    <div id="not-found" class="row">
        <div class="container">
            <section class="not-found-section">
				<h1>
					Erro 404
				</h1>
				<p>Essa página não existe.</p>
				<a href="/" class="call-to-action">
					> Voltar
				</a>
            </section>
        </div>
    </div>
</template>

<style lang="scss" scoped>


#not-found {
	background-image: url("../../img/pricing/bg-pricing-small.png");
	background-repeat: no-repeat;
	background-position: 90% 120%;
	background-size: 310px auto;
	background-color: #1167ac;
	color: white;
	width: 100%;
	height: 40vh;
	min-height: 300px;

	padding-top: 7em;
	padding-bottom: 4em;

	@media (min-width: 450px) {
		padding-top: 8em;
		padding-bottom: 5em;
	}

	@media (min-width: 680px) {
		padding-top: 8em;
		background-image: url("../../img/pricing/bg-pricing.png");
		background-position: 90% 140%;
		background-size: 400px auto;
		height: 40vh;
	}

	@media (min-width: 768px) {
		padding-top: 10em;
		background-image: url("../../img/pricing/bg-pricing.png");
		background-size: 450px auto;
		background-position: 100% 150%;
	}

}

.call-to-action {
	font-size: 30px;
	font-weight: bold;
	font-style: normal;
	color: rgb(113, 252, 195);
	text-transform: lowercase;

	cursor: pointer;
		position: relative;

	&:hover{
		color: rgb(51, 204, 102);
	}
}

.not-found-section p {
	margin-top: 1em;
	margin-bottom: 1em;
	font-size: 18px;
	line-height: 2;
	color: #ffffff;
}



</style>



// WEBPACK FOOTER //
// _source/javascript/components/404.vue